import {ExtraDataService} from "../../../../services/extraDataService";
import {Injectable} from "@angular/core";
import {ExtraData} from "../../../../objects/extraData/extraData";
import {BaseResponse} from "../../../../objects/common/baseResponse";
import {ActivatedRouteSnapshot} from "@angular/router";
import {ReferenceType} from "../../../../objects/extraData/extraDataSearchRequest";

/**
 * Created by alex.y on 9/18/2017.
 */

@Injectable()
export class ExtraDataResolver {

    constructor(private extraDataService: ExtraDataService) {
    }

    public resolve(route: ActivatedRouteSnapshot): Promise<BaseResponse<Array<ExtraData>>> {
        let customerId = route.params["customerid"];

        if (customerId)
            return this.extraDataService.getByRefIdandRefType(customerId, ReferenceType.Order);

        return null;
    }
}



// WEBPACK FOOTER //
// ./app/components/Managment/orderManagement/orderDetails/extraDataResolver.ts